import { render, staticRenderFns } from "./FaqTagsList.vue?vue&type=template&id=ac6e998c&scoped=true"
import script from "./FaqTagsList.vue?vue&type=script&lang=js"
export * from "./FaqTagsList.vue?vue&type=script&lang=js"
import style0 from "./FaqTagsList.vue?vue&type=style&index=0&id=ac6e998c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6e998c",
  null
  
)

export default component.exports